import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Outlet, useParams } from "react-router";
import { isValidLang } from "@/config/routes";

export function LanguageGuard() {
	const { lang } = useParams<{ lang: string }>();
	const { i18n } = useTranslation();

	useEffect(() => {
		if (!lang || !isValidLang(lang)) return;
		i18n.changeLanguage(lang);
		localStorage.setItem("language", lang);
		document.documentElement.lang = lang;
	}, [lang, i18n]);

	if (!lang || !isValidLang(lang)) {
		return <Navigate to="/pl/" replace />;
	}

	return <Outlet />;
}
